module.exports = __webpack_public_path__ + "img/ig.0fc47cdd.svg";